import React, { Component } from 'react';

import styles from './Modal.scss';
import Aux from '../../../_hoc/_Aux';
import Blur from '../../molecules/Blur';


class Modal extends Component {

    shouldComponentUpdate ( nextProps, nextState ) {
        return nextProps.children !== this.props.children;
    }

    componentWillUpdate () {
        //console.log('[Modal] WillUpdate');
    }

    componentDidMount () {
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
    }

    componentWillUnmount () {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
    }

    render () {
        let classNames = "";
        if(this.props.theme=="light"){
            classNames = styles.light
        }
        return (
            <Aux>
                <Blur clicked={this.props.blurClicked}>
                    <div className={classNames}>
                    {this.props.children}
                    </div>
                </Blur>
            </Aux>
        )
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/organisms/Modal/index.js